import { ROLE_HIERARCHY, ROLE_LEVELS, ROLES } from '../constants/roles';

function normalizeRoles(roles) {
  if (!Array.isArray(roles)) {
    return [];
  }
  return roles.filter((role) => typeof role === 'string');
}

function getEffectiveRoles(roles) {
  const normalized = normalizeRoles(roles);
  const effective = new Set();

  normalized.forEach((role) => {
    const inherited = ROLE_HIERARCHY[role] || [];
    if (inherited.length === 0) {
      effective.add(role);
      return;
    }
    inherited.forEach((inheritedRole) => effective.add(inheritedRole));
  });

  return effective;
}

export function hasMinimumRole(roles, minimumRole = ROLES.CASHIER) {
  const normalized = normalizeRoles(roles);
  const minimumLevel = ROLE_LEVELS[minimumRole] || ROLE_LEVELS[ROLES.CASHIER];
  return normalized.some((role) => (ROLE_LEVELS[role] || 0) >= minimumLevel);
}

export function hasAnyRole(roles, requiredRoles = []) {
  const effectiveRoles = getEffectiveRoles(roles);
  return requiredRoles.some((role) => effectiveRoles.has(role));
}

export function canAccessRoute(roles, options = {}) {
  if (options.minimumRole) {
    return hasMinimumRole(roles, options.minimumRole);
  }
  if (Array.isArray(options.anyRoles) && options.anyRoles.length > 0) {
    return hasAnyRole(roles, options.anyRoles);
  }
  return true;
}

export function canShowLink(roles, options = {}) {
  return canAccessRoute(roles, options);
}
